import { useApiOperatorBusinessCaseStatusCountsGet } from "@fllite/api";

import { ActionCounts } from "@/components/Dashboard/Dashboard/timelineSteps";

export interface OperatorBusinessCaseStatusCountsData {
  counts: Record<string, number>;
  actionCounts: ActionCounts;
}

const EMPTY_ACTION_COUNTS: ActionCounts = {
  awaitingApproval: 0,
  manualProposalRequested: 0,
  missingFbo: 0,
  missingCrew: 0,
  paidMissingPax: 0,
  paidMissingFboOrCrew: 0,
  paidComplete: 0,
};

export const useOperatorBusinessCaseStatusCounts = () => {
  const { data, isLoading } = useApiOperatorBusinessCaseStatusCountsGet();

  // `data` is the union of the JSON-LD and plain response shapes; both
  // expose `counts: [{ status, count }]` and `actionCounts: { ... }`. The
  // generated fields are optional (server may omit), so each access is
  // coalesced with a default rather than asserted.
  const normalized: OperatorBusinessCaseStatusCountsData | undefined = data
    ? {
        counts: Array.isArray(data.counts)
          ? data.counts.reduce<Record<string, number>>((acc, row) => {
              if (row?.status) acc[row.status] = row.count ?? 0;
              return acc;
            }, {})
          : {},
        actionCounts: {
          awaitingApproval: data.actionCounts?.awaitingApproval ?? 0,
          manualProposalRequested:
            data.actionCounts?.manualProposalRequested ?? 0,
          missingFbo: data.actionCounts?.missingFbo ?? 0,
          missingCrew: data.actionCounts?.missingCrew ?? 0,
          paidMissingPax: data.actionCounts?.paidMissingPax ?? 0,
          paidMissingFboOrCrew: data.actionCounts?.paidMissingFboOrCrew ?? 0,
          paidComplete: data.actionCounts?.paidComplete ?? 0,
        },
      }
    : undefined;

  return {
    data: normalized,
    actionCounts: normalized?.actionCounts ?? EMPTY_ACTION_COUNTS,
    isLoading,
  };
};
